/**
 * Variable replacement engine for Dyna Agency email templates.
 * Replaces {{variable_name}} placeholders with values from data.
 * Unknown variables are left as-is — no error thrown.
 *
 * Supported variables (caller is responsible for supplying):
 *   {{first_name}}, {{last_name}}, {{full_name}}, {{email}}, {{phone}}
 *   {{business_name}}, {{service_interest}}, {{package}}
 *   {{booking_date}}, {{booking_time}}
 *   {{portal_link}}    — https://www.dyna-agency.com/portal/[client_id]
 *   {{booking_link}}   — https://calendly.com/pinch-dyna-agency/30min
 *   {{month}}, {{dashboard_link}}
 *   Plus any template-specific vars (e.g. {{revision_number}}, {{week}})
 */
export function replaceVariables(
  template: string,
  data: Record<string, string>
): string {
  const resolved: Record<string, string> = { ...data };

  // Auto-compute {{full_name}} from first+last if caller didn't supply it
  if (!resolved.full_name && (resolved.first_name || resolved.last_name)) {
    resolved.full_name = [resolved.first_name, resolved.last_name]
      .filter(Boolean)
      .join(' ');
  }

  return template.replace(/\{\{(\w+)\}\}/g, (_match, key: string) =>
    Object.prototype.hasOwnProperty.call(resolved, key)
      ? resolved[key]
      : `{{${key}}}`
  );
}
